<!--快递应收费用明细-->
<template>
  <el-form
    ref="addBatchFeeRef"
    :model="formData"
    label-width="0"
    size="small"
    class="error-form"
  >
    <el-table
      :data="formData.tableData"
      :height="tableHeight"
      border
    >
      <el-table-column width="55" align="center">
        <template slot="header">
          <span class="el-icon-plus addStyle" @click="addCost()" />
        </template>
        <template slot-scope="scope">
          <!--确定删除吗-->
          <el-popconfirm
            v-if="scope.row.feeSource === 1 && (scope.row.isAccept === false)"
            :title="$t('basicData.AreYouSureDelete')"
            @confirm="deleteCost(scope)"
          >
            <span slot="reference" class="el-icon-delete deleteStyle" />
          </el-popconfirm>
        </template>
      </el-table-column>
      <!--业务类型-->
      <el-table-column
        prop="businessType"
        :label="$t('collectionCenter.businessT')"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <div class="formStyle">
            <div v-if="scope.row.isEdit === false">
              <!-- 快递 -->
              <span v-if="scope.row.businessType === 0">{{ $t('collectionCenter.expressDelivery') }}</span>
              <!-- 揽收 -->
              <span v-if="scope.row.businessType === 1">{{ $t('collectionCenter.lanshou') }}</span>
              <!--  派送 -->
              <span v-if="scope.row.businessType === 2">{{ $t('collectionCenter.dispatch') }}</span>
            </div>
            <el-form-item
              v-else
              :prop="'tableData.' + scope.$index + '.businessType'"
              :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
            >
              <el-select
                v-model="scope.row.businessType"
                filterable
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                style="width: 100%;"
                @change="businessTypeChange(scope)"
              >

                <el-option
                  v-for="item of businessTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <!--费用类型-->
      <el-table-column
        prop="feeName"
        :label="$t('basicData.ExpenseType')"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <div class="formStyle">
            <div v-if="scope.row.isEdit === false">
              {{ scope.row.feeName }}
            </div>
            <el-form-item
              v-else
              :prop="'tableData.' + scope.$index + '.feeCode'"
              :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
            >
              <el-select
                v-model="scope.row.feeCode"
                filterable
                clearable
                :placeholder="$t('operationCenter.PleaseSelect')"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in scope.row.feeTypeOptionList"
                  :key="item.id"
                  :label="item.displayName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <!--是否生成对账单-->
      <el-table-column
        prop="isGenBill"
        :label="$t('receivablePayable.WhetherToGenerateAStatement')"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.isGenBill ? $t('receivablePayable.Generated') : $t('receivablePayable.NotGenerated') }}</div>
        </template>
      </el-table-column>
      <!--是否核收-->
      <el-table-column
        prop="isAccept"
        :label="$t('receivablePayable.WhetherToCheckOrNot')"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.isAccept ? $t('basicData.Received') : $t('basicData.NotReconciled') }}</div>
        </template>
      </el-table-column>
      <!--应收金额-->
      <el-table-column
        prop="fee"
        :label="$t('receivablePayable.AmountReceivable')"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <div class="formStyle">
            <div v-if="scope.row.isEdit === false">
              {{ scope.row.fee }}
            </div>
            <el-form-item
              v-else
              :prop="'tableData.' + scope.$index + '.fee'"
              :rules="{ required: true, suffix: 2, negative: '-?', validator: priceType, trigger: ['blur', 'change'] }"
            >
              <el-input v-model="scope.row.fee" />
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <!--业务时间-->
      <el-table-column
        prop="operateTime"
        :label="$t('basicData.BusinessTime')"
        align="center"
        width="240"
      >
        <template slot-scope="scope">
          <div class="formStyle">
            <div v-if="scope.row.isEdit === false">
              {{ scope.row.operateTime }}
            </div>
            <el-form-item
              v-else
              :prop="'tableData.' + scope.$index + '.operateTime'"
              :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
            >
              <el-date-picker
                v-model="scope.row.operateTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%;"
                :placeholder="$t('basicData.SelectADatetime')"
              />
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <!--录入人员-->
      <el-table-column
        prop="createUser"
        :label="$t('receivablePayable.EnterThePerson')"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div class="formStyle">
            <div v-if="scope.row.isEdit === false">
              {{ createUser[scope.row.createUser] }}
            </div>
            <el-form-item
              v-else
              :prop="'tableData.' + scope.$index + '.createUser'"
            >
              <div>{{ createUser[scope.row.createUser] }}</div>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <!--平摊方式-->
      <el-table-column
        v-if="addType === 1"
        prop="flatMethod"
        :label="$t('receivablePayable.FlatSharingMethod')"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <el-form-item
            :prop="'tableData.' + scope.$index + '.flatMethod'"
            :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
          >
            <el-select
              v-model="scope.row.flatMethod"
              filterable
              clearable
              :placeholder="$t('operationCenter.PleaseSelect')"
              style="width: 100%;"
            >
              <!--按重量平摊-->
              <el-option :label="$t('receivablePayable.SpreadEquallyByWeight')" value="1" />
              <!--按票数平摊-->
              <el-option :label="$t('receivablePayable.SplitEquallyByTheNumberOfVotes')" value="2" />
              <!--指定金额-->
              <el-option :label="$t('receivablePayable.SpecifyTheAmount')" value="3" />
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>
      <!--费用来源-->
      <el-table-column
        prop="feeSource"
        :label="$t('receivablePayable.SourceOfFees')"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          <!-- 1：系统生成 2：手动添加 4：跨境系统； 揽收系统推送-->
          <div>
            <span v-if="scope.row.feeSource === 0">{{ $t('receivablePayable.SystemGenerated') }}</span>
            <span v-else-if="scope.row.feeSource === 1">{{ $t('receivablePayable.AddManually') }}</span>
            <span v-else-if="scope.row.feeSource === 4">{{ $t('receivablePayable.crossBorderSystem') }}</span>
            <span v-else>{{ $t('receivablePayable.CollectionSystemPush') }}</span>
          </div>
        </template>
      </el-table-column>
      <!--备注-->
      <el-table-column
        prop="remark"
        :label="$t('receivablePayable.remark')"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.isEdit === false">
            {{ scope.row.remark }}
          </div>
          <el-form-item
            v-else
            :prop="'tableData.' + scope.$index + '.remark'"
            :rules="{ required: false, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
          >
            <el-input v-model="scope.row.remark" :placeholder="$t('GlobalSetObj.pleaseInputContent')" />
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>
<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import {
  getBatchBusinessTypeList,
  getOneBusinessTypeList
} from '@/views/finance/receivableManagementSite/aRGenerationNew/cmp/utils';
import { feePage } from '@/api/finance/partition';
import { apiReCalculateDeleteFeeDTO } from '@/api/finance/receivables';

export default {
  props: {
    // 费用列表明细
    expenseSubList: {
      type: Array,
      default: () => []
    },
    // 当前列
    queryFeeParam: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 添加类型 1：批量新增（单条） 2：费用详情新增
    addType: {
      type: Number,
      default: 1
    },
    // 搜索条件
    queryForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 费用list
    feeTypeOption: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    const priceType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };
    return {
      priceType,
      tableHeight: 0,
      createUser: getUserIdAndNameObj(),
      formData: {
        tableData: []
      }
    };
  },
  computed: {
    // 获取费用明细业务类型下拉菜单可选项
    businessTypeList() {
      // 费用详情添加
      if (this.addType === 2) {
        const { businessType, billingMethod } = this.queryFeeParam;

        return getOneBusinessTypeList(businessType, billingMethod);
      }
      // 批量添加
      if (this.addType === 1) {
        const { businessType } = this.queryForm;
        return getBatchBusinessTypeList(businessType);
      }

      return [];
    }
  },
  watch: {
    expenseSubList: {
      handler(val) {
        if (!val || val.length === 0) {
          return;
        }
        this.formData.tableData = val;
      },
      deep: true
    }
  },
  created() {
    this.getTableHeight();
  },

  mounted() {
    // 页面加载的时候设置table的高度
    this.getTableHeight();

    // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
    window.onresize = () => {
      this.getTableHeight();
    };
  },

  methods: {
    // 获取table高度
    getTableHeight() {
      this.$nextTick(() => {
        const el = this.$refs.addBatchFeeRef.$el;
        const top = el.offsetTop;
        this.tableHeight = document.body.clientHeight - (top + 87);
      });
    },

    // 业务类型变化
    businessTypeChange(scope) {
      this.formData.tableData[scope.$index].feeName = '';
      this.formData.tableData[scope.$index].feeCode = '';
      // 获取费用类型
      const param = {
        orderDirection: 'ASC',
        pageNumber: 1,
        pageSize: 10000,
        params: {
          state: 1,
          attribute: 1, // 1 应收费用 2 应付费用
          businessType: scope.row.businessType
        }
      };
      feePage(param, false).then(res => {
        if (res.code === 200) {
          this.formData.tableData[scope.$index].feeTypeOptionList = res.data.records;
        }
      }).catch(err => {
        console.error(err);
      });
    },

    // 删除新增
    deleteCost(scope) {
      if (scope.row.id) {
        apiReCalculateDeleteFeeDTO({ id: scope.row.id }).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // '操作成功'
            this.formData.tableData.splice(scope.$index, 1);
          }
        });
      } else {
        this.formData.tableData.splice(scope.$index, 1);
      }
    },

    // 添加费用
    addCost() {
      const data = {
        isEdit: true,
        businessType: '', // 业务类型
        feeName: '', // 费用类型
        feeCode: '',
        feeTypeOptionList: this.feeTypeOption,
        feeSource: 1, // 费用来源
        fee: '', // 应收金额
        isGenBill: 0, // 是否生成对账单
        isAccept: false, // 是否核收
        isOut: 0, // 是否已出库
        billBatchNumber: '', // 对账批次号
        remark: '', // 备注
        createUser: this.$store.state.user.id, // 录入人员
        operateTime: '', // 生成业务时间
        flatMethod: '', // 平摊方式
        chargeWeight: this.queryFeeParam.chargeWeight // 计费重量
      };
      if (this.addType === 1) {
        if (this.formData.tableData.length === 0) {
          this.formData.tableData.push(data);
        } else {
          this.$message.warning(this.$t('receivablePayable.OnlyOneChargeCanBeAdded')); // 只能添加一条费用
        }
      } else {
        this.formData.tableData.push(data);
      }
    },

    // 获取费用汇总
    getFeeTypeOption() {
      // 校验
      if (this.addType === 1) {
        if (this.formData.tableData.length === 0) {
          this.$message.warning(this.$t('receivablePayable.AddAtLeastOneCharge')); // '最少添加一条费用'
          return false;
        }
        if (this.formData.tableData.length > 1) {
          this.$message.warning(this.$t('receivablePayable.OnlyOneChargeCanBeAdded')); // 只能添加一条费用
          return false;
        }
      }
      const { tableData } = this.formData;
      return new Promise((resolve, reject) => {
        this.$refs.addBatchFeeRef.validate(valid => {
          if (valid) {
            resolve(tableData);
            return;
          }
          resolve(false);
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.addStyle {
  color: #00A551;
  cursor: pointer;
  font-size: 18px;
}

.deleteStyle {
  color: #F56C6C;
  cursor: pointer;
  font-size: 18px;
}
</style>
